import { API } from 'aws-amplify';

const getAllLeads = async teamId => {
  try {
    const data = await API.get('agentbuzz', `leads/${teamId}`);
    return { status: true, result: data };
  } catch (error) {
    return { status: false, result: error };
  }
};

export default getAllLeads;



// WEBPACK FOOTER //
// ./src/services/lead/getAllLeads.js